let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9d1Ui")).then(() => parcelRequire('8QGBH'));